import React, { useState, useEffect } from "react";

const facts = [
    "The foreign exchange (forex) market is the world’s largest financial market, with daily trading volume exceeding $6.6 trillion. It’s highly liquid and operates 24 hours a day, 5 days a week.",
    "Bitcoin, the first cryptocurrency, was created in 2009 by an anonymous person or group known as Satoshi Nakamoto.",
    "Forex trading is highly influenced by geopolitical events, economic data releases, and central bank policies.",
    "The concept of blockchain, which underlies cryptocurrencies, ensures that data is secure, transparent, and immutable.",
    "The stock market has historically provided average annual returns of about 7% after inflation, making it a popular long-term investment choice.",
    "Forex trading involves trading currency pairs, such as EUR/USD, where traders speculate on the value of one currency against another.",
    "Ethereum, launched in 2015, introduced smart contracts, allowing decentralized applications (DApps) to be built on its blockchain.",
    "Cryptocurrency is highly volatile, with prices often swinging dramatically in short periods, making it a risky but potentially rewarding investment.",
    "Forex trading is conducted over-the-counter (OTC), meaning there is no centralized exchange, and it happens between financial institutions, brokers, and traders globally.",
    "Diversification is a key principle in investing, helping reduce risk by spreading investments across different asset classes.",
    "Smart trading concepts blend strategy, discipline, and risk management for long-term success.",
    "Prop trading firms provide traders with capital, enabling them to trade without risking their own money.",
    "TradingView is a community-driven platform where traders share charts and ideas.",
    "MT4 is one of the most popular forex trading platforms, renowned for its simplicity and power.",
    "MT5 expands on MT4 with additional tools and broader market access.",
    "PineScript on TradingView lets you create custom indicators in just a few lines of code.",
    "Algorithmic trading uses computer programs to execute trades at lightning speed.",
    "Derivatives are financial instruments that derive their value from an underlying asset without owning it.",
    "Crypto markets never sleep – they're open 24/7, offering non-stop trading action.",
    "Forex trading involves over 200 currencies and countless pairs – it's a global money playground!",
    "Blockchain technology ensures transparency and security in the world of cryptocurrencies.",
    "Decentralized finance (DeFi) is revolutionizing traditional banking by offering peer-to-peer financial services.",
    "Altcoins bring diverse innovations to crypto, each with its own unique twist.",
    "Stablecoins reduce crypto volatility by pegging their value to traditional currencies.",
    "Market sentiment can sometimes be more powerful than technical indicators in predicting price moves.",
    "High-frequency trading algorithms can execute thousands of trades in the blink of an eye.",
    "Central banks wield immense power in forex markets through monetary policy decisions.",
    "The Dow Jones Industrial Average has been a barometer of the U.S. economy for over a century.",
    "Options give traders the right—but not the obligation—to buy or sell at a specific price.",
    "Short selling lets you profit from falling stock prices – but beware, it's risky!",
    "Volume indicators reveal the strength behind a price move in any asset.",
    "Moving averages help smooth out price data, revealing underlying trends.",
    "Bollinger Bands measure volatility and can indicate when a market is overbought or oversold.",
    "The RSI (Relative Strength Index) is a popular tool for spotting potential trend reversals.",
    "The MACD (Moving Average Convergence Divergence) signals momentum changes in the market.",
    "Candlestick charts offer rich detail, showing market sentiment in every formation.",
    "Fibonacci retracement levels often indicate where prices might reverse during trends.",
    "Economic calendars help traders time their moves around key data releases.",
    "Inflation can erode returns, making bonds a vital part of preserving wealth.",
    "Quantitative easing has reshaped asset prices in unprecedented ways over the past decade.",
    "Emerging markets offer explosive growth potential – with high rewards come high risks!",
    "The VIX index, often called the 'fear gauge,' measures market uncertainty.",
    "Dividend stocks deliver income while offering potential for long-term capital appreciation.",
    "Value investing focuses on buying undervalued companies with solid fundamentals.",
    "Growth investing targets companies with high potential, even if they're not currently profitable.",
    "Swing trading capitalizes on short-term trends and market momentum.",
    "Day trading demands quick decision-making and nerves of steel.",
    "Scalping profits from tiny price moves and requires ultra-fast execution.",
    "Diversification is the golden rule of investing to spread and mitigate risk.",
    "The efficient market hypothesis suggests that it's nearly impossible to consistently beat the market.",
    "Behavioral finance explores how psychology drives market behavior.",
    "Market bubbles are fueled by exuberance and often end in spectacular crashes.",
    "A 'buy and hold' strategy has long been a cornerstone of successful investing.",
    "Smart beta strategies aim to improve on market-cap weighting by targeting factors like value and momentum.",
    "Risk management is as crucial as finding the right trade – never risk more than you can afford to lose.",
    "Prop trading desks often offer robust training programs to refine your skills.",
    "Volatility can be a friend or foe, offering opportunities if managed wisely.",
    "The mind of a trader is just as important as the tools on the chart.",
    "Stop losses are your best friend when it comes to limiting downside risk.",
    "A favorable risk-to-reward ratio can make even a modest edge profitable.",
    "Proper position sizing is key to long-term trading success.",
    "Backtesting can validate your trading strategies using historical data.",
    "Algorithmic trading eliminates emotional bias by following strict mathematical rules.",
    "High-frequency trading relies on speed and technology to capture fleeting opportunities.",
    "Cutting-edge tech in prop trading provides access to real-time data and analytics.",
    "TradingView offers a treasure trove of ideas and charts from a global community.",
    "MT4 is a timeless platform favored by forex traders for its reliability.",
    "MT5 builds upon MT4 with enhanced features and broader asset coverage.",
    "PineScript empowers traders to create custom tools and indicators on TradingView.",
    "Automated trading systems can execute strategies without letting emotions intervene.",
    "Derivatives allow for sophisticated hedging and speculative strategies.",
    "Options trading offers flexible strategies, including straddles, strangles, and spreads.",
    "Futures contracts let producers and consumers lock in prices ahead of time.",
    "ETFs have democratized investing by offering low-cost, diversified exposure.",
    "Bonds are the go-to safe haven in times of market turbulence.",
    "Global markets are interconnected; a shock in one region can send ripples worldwide.",
    "Historical market patterns sometimes repeat – learning from the past can be a strategic advantage.",
    "Robo-advisors are making sophisticated portfolio management accessible to everyone.",
    "Exchange-traded notes (ETNs) track indices without the hassle of physical delivery.",
    "Index funds are the foundation of passive investing, providing broad market exposure.",
    "Compound interest is often called the most powerful force in finance.",
    "Volatility indexes gauge market fear and can signal turning points.",
    "Behavioral biases can lead even seasoned investors astray.",
    "Market cycles are as predictable as the seasons – understanding them is key to timing.",
    "Central bank announcements can send shockwaves through the financial markets.",
    "Even on cloudy days, the market can surprise you with brilliant opportunities!",
    "Every asset class has its own personality – from the wild swings of crypto to the steady beat of bonds.",
    "Sometimes the best trade is the one you don't make – patience pays off in investing.",
    "A little humor in the markets can ease the tension on volatile days.",
    "The trading world is full of legends, quirky strategies, and unforgettable market moments.",
    "FinTech innovations are revolutionizing how we invest, trade, and interact with money.",
    "The journey in financial markets is as exciting as it is unpredictable.",
    "Every trader has a unique story – and every market move adds a new chapter!",
    "Stay curious and keep exploring – the financial markets are a never-ending adventure.",
    "Crypto trading is as dynamic as a roller coaster – hold on tight!",
    "Forex traders are globe-trotters, navigating currencies from every corner of the world.",
    "Stock charts are like treasure maps – learn to read them and unlock hidden gems.",
    "Commodities can be as unpredictable as the weather, yet they power our global economy.",
    "Futures let you bet on tomorrow's prices today – a true time machine for traders!",
    "ETFs make investing accessible, letting you own a slice of a diverse market pie.",
    "Bonds are the silent, steady performers that keep your portfolio humming along.",
    "Technical analysis is a detective’s tool, uncovering clues in market patterns.",
    "Fundamental analysis is the art of reading a company’s financial diary.",
    "Trading psychology is the secret ingredient for success – master your mind, master the market.",
    "Smart trading combines data, intuition, and a dash of daring.",
    "Prop trading firms are like exclusive clubs where skill and strategy are the currency.",
    "TradingView is where chart enthusiasts come to share their ‘aha!’ moments.",
    "MT4 remains a timeless favorite in the forex community for its simplicity and power.",
    "MT5 offers a modern upgrade, packed with new tools for the savvy trader.",
    "PineScript lets you turn your trading ideas into reality with just a few lines of code.",
    "Algorithmic trading is like having a supercomputer as your personal trader.",
    "Derivatives provide creative ways to hedge risks or amplify gains.",
    "Smart trading is all about strategy, precision, and a dash of humor in the face of volatility.",
    "Every asset class tells its own story – dive in and discover a world of opportunity.",
    "Financial markets are a playground for the curious – explore, learn, and have fun!",
    "Even the wildest market swings can lead to brilliant trading opportunities.",
    "Market trivia: The first stock exchange was established in Amsterdam in 1602!",
    "Crypto slang like 'HODL' means 'Hold On for Dear Life' – and it’s not far from the truth!",
    "Forex markets operate 24 hours a day – sleep is optional for true currency warriors!",
    "Stock market legends say that patience is the ultimate key to wealth.",
    "Commodity prices can change on a whim – sometimes more unpredictable than the weather!",
    "Futures contracts let you forecast tomorrow's prices – it’s like financial clairvoyance.",
    "ETFs have changed the game by making diversification as easy as a single click.",
    "Bonds might be boring to some, but they are the unsung heroes of long-term wealth.",
    "Technical indicators are like secret signals from the market – learn their language.",
    "Fundamental analysis is a bit like detective work – digging deep to find hidden value.",
    "Trading psychology can be a roller coaster – keep your emotions in check and ride the waves.",
    "Smart trading means using every tool at your disposal – data, intuition, and a sprinkle of humor.",
    "Prop trading is a high-stakes game where only the best strategies survive.",
    "Chart patterns can be as fascinating as art – every candlestick tells a story.",
    "MT4 and MT5 continue to empower traders with robust, reliable platforms.",
    "PineScript lets you be the architect of your own trading indicators.",
    "Algorithmic trading is the fusion of finance and technology – think of it as market robotics.",
    "Derivatives are versatile tools – from hedging risks to taking bold speculative bets.",
    "The financial markets are full of surprises – sometimes the best trade/investment is simply to learn something new.",
    "Every day in the market is a lesson in human behavior, strategy, and resilience.",
    "Some of the best investment ideas come when you least expect them – stay alert and curious.",
    "Market humor can be a great stress-reliever – after all, even the markets have a quirky side!",
    "In trading, knowledge is power – and a bit of fun makes the journey even more rewarding."
];

const Facts = ({ onContinue }) => {
  const [fact, setFact] = useState("");
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setFact(facts[Math.floor(Math.random() * facts.length)]); // Select a random fact
    setAnimate(true);
  }, []);

  return (
    <div style={{ textAlign: "center", padding: "20px", backgroundColor: "black", color: "white", minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
      
      {/* Title */}
      <h1 style={{ color: "#FF7C24", marginBottom: "20px" }}>Did you know?</h1>
      
      {/* Fact Content */}
      <p style={{ fontSize: "20px", maxWidth: "80%", margin: "0 auto", padding: "10px" }}>
        {fact}
      </p>

      {/* Animated Lightbulb */}
      <div style={{ fontSize: "50px", margin: "20px 0", transform: animate ? "scale(1.3)" : "scale(1)", transition: "transform 0.3s ease-in-out" }}>
        💡
      </div>

      {/* Continue Button */}
      <button 
  onClick={() => {
    //console.log("Continue button clicked!");
    onContinue();
  }} 
  style={{
    backgroundColor: "#FF7C24", 
    color: "white", 
    padding: "10px 20px", 
    fontSize: "18px", 
    border: "none", 
    borderRadius: "10px", 
    cursor: "pointer",
    marginTop: "20px"
  }}
>
  Continue
</button>

    </div>
  );
};

export default Facts;
